import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'humanize'
})
export class HumanizeStringPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return value ? value.humanize() : '';
  }
}
